@import '../../shared';

.form-radio {
  display: flex;
  align-items: flex-start;
  position: relative;
  margin-bottom: 1.5rem;

  &__box {
    display: none;
  }

  &__group {
    display: flex;
  }

  &__hidden {
    position: absolute;
    left: auto;
    right: auto;
    top: 3.2rem;
    opacity: 0;
  }

  &__styled {
    @include form-component;
    height: 3.2rem;
    width: 3.2rem;
    border-radius: 50%;
    margin-right: 1.5rem;
    display: inline-block;
  }

  &__image {
    &-container {
      border: 0.2rem solid #fff;
      box-shadow: 0 0.4rem 0.8rem 0 $shadow-color;
      border-radius: 50%;
      overflow: hidden;
      height: 6rem;
      width: 6rem;

      @media (min-width: $breakpoint-md) {
        width: 8rem;
        height: 8rem;
      }
    }
  }

  &:hover,
  &:focus {
    cursor: pointer;

    .form-radio__caption--border {
      background-color: $blue-page-heading;
      color: #fff;
    }
  }
}


input[type='radio']:checked ~ .form-radio__image-container {
  border-color: $dark-purple;
}

input[type='radio']:checked ~ .form-radio__caption--border {
  background-color: $dark-purple;
  color: #fff;
}

.form-radio__image {
  height: 100%;
  width: 100%;
  border: 0.2rem solid #fff;
  border-radius: 50%;
}

.form-radio__styled--disabled {
  @include form-component-disabled;
}

.form-radio__caption {
  padding-top: 0.2rem;

  &--border {
    border: 0.1rem solid $blue-page-heading;
    padding: 1rem;
    color: $blue-page-heading;
    font-weight: bold;
  }
}

.form-radio--disabled {
  .form-radio__caption {
    font-style: italic;
    color: $text-color-secondary;
  }
  .form-radio__image-container {
    border-color: $border-color;
  }
  .form-radio__image {
    opacity: 0.35;
  }
}

.form-radio__dot {
  display: none;
  position: absolute;
  top: 0.4rem;
  left: 0.4rem;
  fill: $blue;
}

input[type='radio']:checked ~ .form-radio__caption {
  font-weight: bold;
}

input[type='radio']:focus ~ .form-radio__styled {
  border-color: $blue;
}

input[type='radio']:checked + .form-radio__dot {
  display: block;
}